import React, { useEffect, useState } from "react";
import {
  FiArrowRight,
  FiClipboard,
  FiLayers,
  FiSearch,
  FiTrendingUp,
} from "react-icons/fi";
import "./HomeHeroSlider.css";

const orbitOneUrl = "https://orbitone.live";

const slides = [
  {
    eyebrow: "Incorporation Workflow",
    title: "Track every step\nof your venture setup",
    description:
      "From lead capture to KYC, filings and workspace readiness, follow the full incorporation journey in one place.",
    ctaPrimary: "Explore setup",
    ctaSecondary: "See how it works",
    accent: "#0b61d6",
    mainImage: "/assets/hero/incorporation-progress.png",
    mainPosition: "66% top",
    backgroundPhones: [
      { src: "/assets/hero/business-growth.png", position: "57% top", className: "phone-back-left" },
      { src: "/assets/hero/services.png", position: "67% top", className: "phone-back-right" },
    ],
  },
  {
    eyebrow: "Business Growth",
    title: "Turn signals\ninto real business\nopportunities",
    description:
      "See generated leads, assign consultants, respond quickly and convert prospects into revenue from one connected growth workspace.",
    ctaPrimary: "Explore growth",
    ctaSecondary: "View lead flow",
    accent: "#1457ff",
    mainImage: "/assets/hero/business-growth.png",
    mainPosition: "57% top",
    backgroundPhones: [
      { src: "/assets/hero/services.png", position: "67% top", className: "phone-back-left" },
      { src: "/assets/hero/requests.png", position: "65% top", className: "phone-back-right" },
    ],
  },
  {
    eyebrow: "Managed Services",
    title: "Raise the help\nyou need without\nslowing down",
    description:
      "From funding support to registrations, UPI QR, sound box and compliance help, create requests with clear actions and visible timelines.",
    ctaPrimary: "Open requests",
    ctaSecondary: "See services",
    accent: "#0b61d6",
    mainImage: "/assets/hero/requests.png",
    mainPosition: "65% top",
    backgroundPhones: [
      { src: "/assets/hero/services.png", position: "67% top", className: "phone-back-left" },
      { src: "/assets/hero/org-structure.png", position: "72% top", className: "phone-back-right" },
    ],
  },
];

const quickActions = [
  { icon: <FiClipboard />, title: "Start journey", detail: "Launch with confidence" },
  { icon: <FiLayers />, title: "Build presence", detail: "Go live online" },
  { icon: <FiSearch />, title: "Find growth", detail: "Discover opportunities" },
  { icon: <FiTrendingUp />, title: "Scale smart", detail: "Automate as you grow" },
];

function HomeHeroSlider() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const slide = slides[activeIndex];

  useEffect(() => {
    if (isPaused) return undefined;

    const timer = window.setInterval(() => {
      setActiveIndex((current) => (current + 1) % slides.length);
    }, 4500);

    return () => window.clearInterval(timer);
  }, [isPaused]);

  return (
    <section
      className="home-hero-slider"
      style={{ "--hero-accent": slide.accent }}
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <div className="home-hero-frame">
        <div className="home-hero-copy" key={`copy-${activeIndex}`}>
          <p className="home-hero-eyebrow">{slide.eyebrow}</p>
          <h1>
            {slide.title.split("\n").map((line) => (
              <span key={line}>{line}</span>
            ))}
          </h1>
          <p className="home-hero-description">{slide.description}</p>
          <div className="home-hero-actions">
            <a href={orbitOneUrl} className="home-hero-primary">
              {slide.ctaPrimary}
              <FiArrowRight />
            </a>
            <a href={orbitOneUrl} className="home-hero-secondary">
              {slide.ctaSecondary}
              <FiArrowRight />
            </a>
          </div>
          <div className="home-hero-dots">
            {slides.map((_, index) => (
              <button
                key={index}
                type="button"
                className={`home-hero-dot ${index === activeIndex ? "active" : ""}`}
                onClick={() => setActiveIndex(index)}
                aria-label={`Show slide ${index + 1}`}
              />
            ))}
          </div>
        </div>

        <div className="home-hero-visual" aria-hidden="true">
          <div className="home-phone-scene" key={`scene-${activeIndex}`}>
            <div className="home-visual-dots" />
            {slide.backgroundPhones.map((phone) => (
              <DeviceFrame
                key={`${phone.src}-${phone.className}`}
                image={phone.src}
                objectPosition={phone.position}
                className={`phone-frame-back ${phone.className}`}
              />
            ))}
            <DeviceFrame
              image={slide.mainImage}
              objectPosition={slide.mainPosition}
              className="phone-frame-main"
            />
          </div>
        </div>
      </div>

      <div className="home-hero-ribbon">
        {quickActions.map((action) => (
          <div className="ribbon-entry" key={action.title}>
            <span className="ribbon-symbol">{action.icon}</span>
            <div>
              <strong>{action.title}</strong>
              <span>{action.detail}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

function DeviceFrame({ image, objectPosition, className }) {
  return (
    <div className={`phone-frame ${className}`}>
      <img src={image} alt="" style={{ objectPosition }} />
    </div>
  );
}

export default HomeHeroSlider;
